import DefaultLayout from "layouts/Default";
import LocationLayout from "layouts/LocationLayout";
import {wrapper} from "lib/store";
import {getLocation} from "lib/features/locationSlice";
import {useDispatch, useSelector} from "react-redux";
import Container from "components/blocks/Container";
import Wrapper from "components/blocks/Wrapper";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {solid} from "@fortawesome/fontawesome-svg-core/import.macro";
import {DateTime} from "luxon";
import _ from 'lodash'
import {useEffect, useState} from "react";
import calcOpenNow from "lib/utils/calcOpenNow";
import {
  faFacebookF, faTwitter, faInstagram, faLinkedinIn, faYoutube
} from '@fortawesome/free-brands-svg-icons'
import {locate, isValidEmail, checkMobile} from '../../../../utils/helper'


import {
  faTruck,
  faBagShopping,
  faCar,
  faCircleParking,
  faCalendarCheck,
  faUserDoctor,
  faTag,
  faWheelchair,
  faIdCard,
  faMoneyBill,
  faCreditCard,
  faFlask,
  faHouseMedical,
  faCertificate,
  faVideo,
  faLock,
  faImage,
} from '@fortawesome/pro-solid-svg-icons'

const AMENITY_ICONS = {
  'amenities_Delivery': faTruck,
  'amenities_Onsitepickup': faBagShopping,
  'amenities_Curbsidepickup': faCar,
  'amenities_Freeparking': faCircleParking,
  'amenities_Reservation': faCalendarCheck,
  'amenities_Doctoronsite': faUserDoctor,
  'amenities_Specialoffer': faTag,
  'amenities_Accessible': faWheelchair,
  'amenities_Minimumage18': faIdCard,
  'amenities_Minimumage19': faIdCard,
  'amenities_Minimumage21': faIdCard,
  'amenities_ATM': faMoneyBill,
  'amenities_AcceptCreditCard': faCreditCard,
  'amenities_LabTested': faFlask,
  'amenities_Medical': faHouseMedical,
  'amenities_BrandVerified': faCertificate,
  'amenities_Videos': faVideo,
  'amenities_Security': faLock,
  'amenities_Photos': faImage,
}
import config from '../../../../data/config.json'
import {serverSideTranslations} from "next-i18next/serverSideTranslations";
import {useTranslation} from "next-i18next";
const MARKER = config.map.marker
export const getServerSideProps = wrapper.getServerSideProps(store => async (context) => {
  const {
    query,locale,
  } = context
  await store.dispatch(getLocation({slug: query.locationSlug, id: query.id}))
  return {
    props: {
      ...(await serverSideTranslations(locale, ['home', 'common']))
    }
  }
})

export default function About(props) {
  const location = useSelector(state => state.location.location)
  const [openNow, setOpenNow] = useState(false)
  const [hoursToday, setHoursToday] = useState('')
  const [amenities, setAmenities] = useState([])
  const [geo, setGeo] = useState({
    located: false,
    latitude: 0,
    longitude: 0,
  })
  const [loaded, setLoaded] = useState(false)
  const [isMobile, setIsMobile] = useState(false)


  const { t } = useTranslation()

  useEffect(() => {
    const {isOpen, openTime, closeTime} = calcOpenNow(location.business_hours, location.timezone)
    setOpenNow(isOpen)
    setHoursToday(`${openTime} - ${closeTime}`)
    console.log('location: ', location)
    locate(setGeo)
    arrangeAmenities()
    setLoaded(true)
  }, [])

  useEffect(() => {
    if (loaded) {
      setIsMobile(checkMobile())
    }
  }, [loaded])

  const arrangeAmenities = () => {
    let allAmenities = config.location.amenities
    let ownedAmenitiesId = location.amenities
    let amenitiesList = ownedAmenitiesId.map(item => {
      return allAmenities[Number(item) - 1]
    })
    setAmenities(amenitiesList.filter(item => !!item))
  }


  return (
    <Wrapper>
      <Container className={isMobile ? 'flex flex-col' : 'flex gap-8 items-start'}>
        <div className={isMobile ? 'w-full order-2 mt-5' : 'w-7/12'}>
          {
            location.introduction &&
            <section className={'mb-8'}>
              <h2 className={'font-bold mb-3'}>
                {t('home:store_introduction')}
              </h2>
              <p>
                {location.introduction}
              </p>
            </section>
          }
          {
            location.about &&
            <section className={'mb-8'}>
              <h2 className={'font-bold mb-3'}>
                {t('home:store_aboutUs')}
              </h2>
              <p>
                {location.about}
              </p>
            </section>
          }
          {
            location.amenities?.length &&
            <section className={'mb-8'}>
              <h2 className={'font-bold mb-6'}>
                {t('home:store_amenities')}
              </h2>
              <div className="grid grid-cols-[repeat(auto-fit,minmax(70px,1fr))] gap-6">
                {
                  amenities.length > 0 && amenities.map(a => (
                    <div key={a.key} className="text-center leading-tight text-gray-500">
                      <FontAwesomeIcon icon={AMENITY_ICONS[a.key]} className={"text-2xl"}/> <br/>
                      <span className="text-xs">{a.name}</span>
                    </div>
                  ))
                }
              </div>
            </section>
          }
          {
            location.announcement &&
            <section className={'mb-8'}>
              <h2 className={'font-bold mb-3'}>
                {t('home:store_announcement')}
              </h2>
              <p>
                {location.announcement}
              </p>
            </section>
          }
        </div>
        <div className={isMobile ? "w-full order-1 border rounded-md overflow-hidden " : "w-5/12 border rounded-md overflow-hidden "}>
          <div className="relative overflow-hidden after:content-[''] after:pb-[56.25%] after:block">
            <img src={`
              https://maps.googleapis.com/maps/api/staticmap?zoom=17&size=640x360&markers=${encodeURIComponent(`color:blue|${location.latitude},${location.longitude}`)}&key=AIzaSyAjKpb5fMYUxjqYLuCj5No8vhC9gXR3nKk
            `} alt={''} className={"absolute inset-0 object-cover"}/>
          </div>
          <div className="p-6">
            <section className="flex items-start gap-3 mb-4">
              <FontAwesomeIcon className={'w-7 text-xl text-gray-500 translate-y-0.5'} icon={solid('location-dot')}/>
              <div>
                {location.address} <br/>
                {`${location.city}, ${location.region}, ${location.country}, ${location.zip_code}`} <br/>
                <a href={geo.located ? `https://maps.google.com/maps/dir/${geo.latitude},${geo.longitude}/${location.latitude},${location.longitude}` : `https://www.google.com/maps/place/${location.latitude},${location.longitude}`}
                   target={'_blank'} rel={'noreferrer'}
                   className={'font-bold text-primary-dark'}
                >
                  {t('home:store_getDirection')}
                </a>
              </div>
            </section>
            <section className="flex items-start gap-3 mb-4">
              <FontAwesomeIcon className={'w-7 text-xl text-gray-500 translate-y-0.5'} icon={solid('phone-volume')}/>
              <div>
                <a href={`tel:${location.phone_number}`}>
                  {location.phone_number}
                </a>
              </div>
            </section>
            <section className="flex items-start gap-3 mb-4">
              <FontAwesomeIcon className={'w-7 text-xl text-gray-500 translate-y-0.5'} icon={solid('clock')}/>
              <div>
                <div className={'mb-1'}>
                  <div className="inline-block mr-4 w-28 font-bold text-primary-dark">
                    {openNow ? t('home:openNow') : t('home:closed')}
                  </div>
                  {hoursToday}
                </div>
                {
                  ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'].map(day => {
                    return (
                      location.business_hours && location.business_hours.hasOwnProperty(day) &&
                      <div key={day} className={'mb-1'}>
                        <div className="inline-block mr-4 w-28">
                          {_.capitalize(day)}
                        </div>
                        {DateTime.fromFormat(location.business_hours[day].open, 'hh:mma').toFormat('hh:mm a').toUpperCase()}
                        {' - '}
                        {DateTime.fromFormat(location.business_hours[day].close, 'hh:mma').toFormat('hh:mm a').toUpperCase()}
                      </div>
                    )
                  })
                }
              </div>
            </section>
            <section className="flex items-start gap-3 mb-4">
              <FontAwesomeIcon className={'w-7 text-xl text-gray-500 translate-y-0.5'} icon={solid('envelope')}/>
              <div>
                {
                  isValidEmail(location.email) ?
                      <a href={`mailto:${location.email}`}>
                        {location.email}
                      </a> :
                      null

                }
              </div>
            </section>
            {
              location.website && <section className="flex items-start gap-3 mb-4">
                <FontAwesomeIcon className={'w-7 text-xl text-gray-500 translate-y-0.5'} icon={solid('link')}/>
                <div>
                  <a href={`${location.website}`} target={'_blank'} rel={'noreferrer'}>
                    {t('home:visit_website')}
                  </a>
                </div>
              </section>
            }
            {
              location.social?.facebook && <section className="flex items-start gap-3 mb-4">
                <FontAwesomeIcon className={'w-7 text-xl text-gray-500 translate-y-0.5'} icon={faFacebookF}/>
                <div>
                  <a href={`https://facebook.com/${location.social.facebook}`} target={'_blank'} rel={'noreferrer'}>
                    @{location.social.facebook}
                  </a>
                </div>
              </section>
            }
            {
              location.social?.instagram && <section className="flex items-start gap-3 mb-4">
                <FontAwesomeIcon className={'w-7 text-xl text-gray-500 translate-y-0.5'} icon={faInstagram}/>
                <div>
                  <a href={`https://instagram.com/${location.social.instagram}`} target={'_blank'} rel={'noreferrer'}>
                    @{location.social.instagram}
                  </a>
                </div>
              </section>
            }
            {
              location.social?.twitter && <section className="flex items-start gap-3 mb-4">
                <FontAwesomeIcon className={'w-7 text-xl text-gray-500 translate-y-0.5'} icon={faTwitter}/>
                <div>
                  <a href={`https://twitter.com/${location.social.twitter}`} target={'_blank'} rel={'noreferrer'}>
                    @{location.social.twitter}
                  </a>
                </div>
              </section>
            }
            {
              location.social?.linkedin && <section className="flex items-start gap-3 mb-4">
                <FontAwesomeIcon className={'w-7 text-xl text-gray-500 translate-y-0.5'} icon={faLinkedinIn}/>
                <div>
                  <a href={`https://linkedin.com/${location.social.linkedin}`} target={'_blank'} rel={'noreferrer'}>
                    @{location.social.linkedin}
                  </a>
                </div>
              </section>
            }
            {
              location.social?.youtube && <section className="flex items-start gap-3 mb-4">
                <FontAwesomeIcon className={'w-7 text-xl text-gray-500 translate-y-0.5'} icon={faYoutube}/>
                <div>
                  <a href={`https://youtube.com/${location.social.youtube}`} target={'_blank'} rel={'noreferrer'}>
                    @{location.social.youtube}
                  </a>
                </div>
              </section>
            }
          </div>
        </div>
      </Container>
    </Wrapper>
  )
}

About.getLayout = function getLayout(page) {
  return (
    <DefaultLayout>
      <LocationLayout>
        {page}
      </LocationLayout>
    </DefaultLayout>
  )
}
